import { Card } from "antd";
import { useEffect, useState } from "react";

import { Link, useNavigate, useOutletContext, useParams, useSearchParams } from "react-router-dom";
import { useApiCall } from "../../services/api";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { calcInStock, handleRouteNav } from "../../utils";
import CustomBadge from "../../components/Charts/CustomBadge";

const NewlyAddedProducts = () => {
  const { role_id, customer_id, is_customer } = useSelector((state) => state.auth);
  const { postApi, loading } = useApiCall();
  const navigate = useNavigate();
  const [productData, setProductData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const { type } = useParams();
  const endpoint = type == "now-trending" ? "newly" : type == "top-selling" ? "best-seller" : "";

  const fetchProducts = async () => {
    if (type !== "now-trending" && type !== "top-selling") {
      return navigate("/");
    }

    try {
      const response = await postApi("product/" + endpoint, {
        search: query,
        customer_id: customer_id,
      });

      const formattedRows = (response?.data || []).map((item) => ({
        ...item,
        productImageUrl: item.product?.product_pic_url,
      }));
      setProductData(formattedRows);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProducts();
    }, 300);

    return () => clearTimeout(handler);
  }, [query]);

  const handleRowClick = (record) => {
    navigate(handleRouteNav(`/product-details/${record.sort_no}`, role_id));
  };

  const onSearch = (value, _e, info) =>
    console.log(info === null || info === void 0 ? void 0 : info.source, value);

  const handleOnSearchChange = (e) => {
    const value = e.target.value;
    setSearchParams(
      (prev) => {
        if (value) prev.set("q", value);
        else prev.delete("q");
        return prev;
      },
      { replace: true },
    );
  };

  const { setTitle, setDescription, setBackButton } = useOutletContext();

  const toggleFav = (e, index) => {
    e.stopPropagation();
    e.preventDefault();

    setProductData((prev) =>
      prev.map((item, i) => {
        if (i === index) {
          const isCurrentlyFav = item?.product?.wishlist_tag === "yes";

          return {
            ...item,
            product: {
              ...item.product,
              wishlist_tag: isCurrentlyFav ? "no" : "yes",
            },
          };
        }
        return item;
      }),
    );

    const item = productData[index];
    if (item?.product?.wishlist_tag === "yes") {
      rmoveWishlistItem(item);
    } else {
      addWishlistItem(item);
    }
  };

  const addWishlistItem = async (item) => {
    const payload = {
      customer_id: customer_id,
      product_id: item?.product?.product_id,
      sort_no: item?.product?.sort_no,
    };
    const res = await postApi("wishlist/add-wishlist", payload);
  };

  const rmoveWishlistItem = async (item) => {
    const payload = {
      customer_id: customer_id,
      product_id: item?.product?.product_id,
      sort_no: item?.product?.sort_no,
    };
    const res = await postApi("wishlist/delete-wishlist-product", payload);
  };

  useEffect(() => {
    setTitle(type == "now-trending" ? "Now Trending" : type == "top-selling" ? "Top Selling" : "");
    setBackButton(true);
  }, [setTitle, setDescription, setBackButton]);

  return (
    <>
      <>
        <div className="bg-[#FFFFFF]" style={{ borderRadius: "32px", overflow: "hidden" }}>
          {/* <div className="flex justify-between gap-7 items-center px-8 py-6">
            <SearchInput
              onSearch={onSearch}
              value={query}
              onChange={handleOnSearchChange}
              placeholder="Search for products"
            />
          </div> */}
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <Loader size={60} />{" "}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-6">
              {productData.map((item, i) => (
                <Card
                  key={i}
                  hoverable
                  variant="outlined"
                  style={{
                    borderRadius: 14,
                    overflow: "hidden",
                  }}
                  onClick={() => handleRowClick(item)}
                  cover={
                    <div style={{ position: "relative" }}>
                      <div className="p-3">
                        <img
                          src={
                            item.product?.product_pic_url ||
                            "/assets/images/place_holder_image1.svg"
                          }
                          onError={(e) =>
                            (e.currentTarget.src = "/assets/images/place_holder_image1.svg")
                          }
                          className="rounded-xl w-full h-48 object-cover"
                        />
                      </div>

                      {/* Status Pill */}
                      <div
                        style={{
                          position: "absolute",
                          top: 24,
                          left: 24,
                        }}
                      >
                        {calcInStock(
                          item.quality_shade?.bsr_stock_cases,
                          item.quality_shade?.dcl_stockmtrs,
                        ) ? (
                          <CustomBadge
                            dotClassName="mr-3"
                            customColors={{ bgColor: "#00000066", textColor: "#fff" }}
                            variant="success"
                            text="In Stock"
                          />
                        ) : (
                          <CustomBadge
                            dotClassName="mr-3"
                            customColors={{ bgColor: "#00000066", textColor: "#fff" }}
                            variant="pending"
                            text="Make to order"
                          />
                        )}
                      </div>

                      {/* Favorite Icon */}
                      <div
                        onClick={(e) => toggleFav(e, i)}
                        style={{
                          position: "absolute",
                          top: 24,
                          right: 24,
                          width: 36,
                          height: 36,
                          borderRadius: "10px",
                          background: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                        }}
                        className="border border-transparent hover:border-[#A33434] transition-all duration-200"
                      >
                        {item?.product?.wishlist_tag == "yes" ? (
                          <svg
                            width="21"
                            height="18"
                            viewBox="0 0 21 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21 5.8125C21 12.375 11.2697 17.6869 10.8553 17.9062C10.7461 17.965 10.624 17.9958 10.5 17.9958C10.376 17.9958 10.2539 17.965 10.1447 17.9062C9.73031 17.6869 0 12.375 0 5.8125C0.00173694 4.27146 0.614681 2.79404 1.70436 1.70436C2.79404 0.614681 4.27146 0.00173694 5.8125 0C7.74844 0 9.44344 0.8325 10.5 2.23969C11.5566 0.8325 13.2516 0 15.1875 0C16.7285 0.00173694 18.206 0.614681 19.2956 1.70436C20.3853 2.79404 20.9983 4.27146 21 5.8125Z"
                              fill="#A33434"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="21"
                            height="18"
                            viewBox="0 0 21 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              opacity="0.1"
                              d="M21 5.8125C21 12.375 11.2697 17.6869 10.8553 17.9062C10.7461 17.965 10.624 17.9958 10.5 17.9958C10.376 17.9958 10.2539 17.965 10.1447 17.9062C9.73031 17.6869 0 12.375 0 5.8125C0.00173694 4.27146 0.614681 2.79404 1.70436 1.70436C2.79404 0.614681 4.27146 0.00173694 5.8125 0C7.74844 0 9.44344 0.8325 10.5 2.23969C11.5566 0.8325 13.2516 0 15.1875 0C16.7285 0.00173694 18.206 0.614681 19.2956 1.70436C20.3853 2.79404 20.9983 4.27146 21 5.8125Z"
                              fill="black"
                            />
                          </svg>
                        )}
                      </div>
                    </div>
                  }
                >
                  {/* Bottom Card Content */}
                  <div className="flex justify-between mb-2 text-start">
                    <div>
                      <div className="font-semibold text-base">{item?.short_name}</div>
                      <div className="text-gray-500 text-sm">{item?.clienttype}</div>
                    </div>

                    <div className="text-base text-gray-600">{Number(item.finish_width)}''</div>
                  </div>

                  {/* <div className="flex items-baseline gap-2">
                    <div className="text-xl font-bold">₹{item.rate}</div>
                    <div className="text-gray-500 text-sm">/ meter</div>
                  </div> */}
                </Card>
              ))}
            </div>
          )}
        </div>
      </>
    </>
  );
};

export default NewlyAddedProducts;
